import { FunctionComponent } from 'react'

import { JSONWidgetType as TeaserStandardVerticalJSONWidgetType } from '@widgets/TeaserStandardVertical'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import MostCommented from '@components/MostCommented'
import MostRead from '@components/MostRead'

export type StoryAPIProps = TeaserStandardVerticalJSONWidgetType & {
  aureusOfferId?: string
  commentCount?: number
}

export type ToplistType = 'most-read' | 'most-commented'

export interface ToplistAPIProps {
  title: string
  type: ToplistType
  hideOnDesktop?: boolean
}

const Toplist: FunctionComponent<ToplistAPIProps> = ({
  title,
  type,
  hideOnDesktop,
}) =>
  type === 'most-read' ? (
    <MostRead title={title} hideOnDesktop={hideOnDesktop} />
  ) : (
    <MostCommented title={title} hideOnDesktop={hideOnDesktop} />
  )

const widget = {
  kind: ['toplist'],
  component: Toplist,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
